module.exports = __webpack_public_path__ + "img/cx_img2.71512005.png";